import { faTruckFast } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GeneralTexts } from '../../language/Texts';
import { IDocument } from '../../models/IDocument';
import AccordionComponent from '../accordionComponent/AccordionComponent';
import SectionTitle from '../sectionTitle/SectionTitle';

interface DocumentProps {
    documentList: IDocument[]
}

function DocumentsOnDelievery({ documentList }: DocumentProps) {
    const componentBody =
        <div className="document_list">
            {documentList?.map((document, index) => {
                return (
                    <a
                        key={index}
                        className="doc_link"
                        href={document.link}
                        rel="noreferrer"
                        type={document.mimeType}
                        target="_blank"
                        data-testid="document_link"
                    >
                        {document.title}
                    </a>
                )
            })
            }
        </div>

    const titleComponent =
        <SectionTitle
            icon={<FontAwesomeIcon
                className="section_title_icon"
                icon={faTruckFast} />}
            title={GeneralTexts.documentationUponDelivery} />

    return (
        <>
            {documentList.length > 0 &&
                <AccordionComponent
                    title={titleComponent}
                    body={componentBody}
                />}
        </>
    )
}

export default DocumentsOnDelievery
